<template lang="pug">
.order__item
  .order__full
    .order__item__left
      .order__item__title.h2-title {{video.title}}

      .order__item__expired
        span.text {{limitStr(video.performance.shortDescription, 130)}}
      .order__floor
        .info-text.copy-right(v-if="video.copyright")
          | {{video.copyright.vatNumber}}, {{video.copyright.name}}, {{video.copyright.addess}}

      .order__footer
        arc-button(:name="$t('common.watch')", @click="toVideo()", outline-gray)
    //- .order__item__separator
    .order__item__right.video-part
      picture.video__image
        img.video-img(:src="video.performance.image['170x240']")

</template>

<script>
export default {
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toVideo() {
      let isProd = true;
      if (process.browser && window) {
        isProd = window.location.href.match(/^https:\//);
      }
      if (isProd) {
        window.open(`https://24afisha.by/ru/minsk/videos/${this.video.id}`);
      }
      window.open(`http://afisha.24.arcom.of.by/ru/minsk/videos/${this.video.id}`);
    },
    limitStr(str, n, symb) {
      const s = str.replace(/<\/?[^>]+>/g, '');
      if (!n && !symb) return s;
      symb = symb || '...';
      return s.substr(0, n - symb.length) + symb;
    },
  },
};
</script>

<style lang="scss">
.copy-right {
  margin-left: 0 !important;
}
.video-part {
  // min-height: 260px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video__image {
  width: 170px;
}
.video-img {
  max-height: 100%;
  min-width: 170px;
  width: auto;
}

</style>
